module.exports = __webpack_public_path__ + "static/img/wu.8b83ccb6.png";